<template>
    <div
        class="highlight"
    >
        <div class="text title" v-html="layout.title"/>
        <div class="row baseline-row">
            <div class="division">
                <div class="text" v-html="layout.baseline"/>
            </div>
        </div>
        <div class="row">
            <div class="division" v-if="layout.subtitle">
                <div class="text subtitle" v-html="layout.subtitle"/>
            </div>
            <div class="division" v-if="layout.description">
                <div class="text" v-html="layout.description"/>
            </div>
        </div>
        <div class="row">
            <div class="division">
                <Cta
                    :type="'router-link'"
                    :to="$trl({
                        name: layout.cta.link
                    })"
                    class="link"
                >
                    {{layout.cta.caption}}
                </Cta>
            </div>
        </div>
    </div>
</template>
<script>
import Cta from '@/components/Cta'
export default {
    components: {
        Cta
    },
    props: {
        layout: {
            type: Object,
            default() {}
        }
    }

}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.highlight
    margin-top: 14%
    margin-bottom: 12%
    padding-right: 9.6%
    padding-left: 9.6%
    /deep/ h1 + h1
        margin-top: 0
    @media print
        page-break-inside: avoid
        break-inside: avoid
        margin-top: 1.2cm
        margin-bottom: 1.2cm
.title
    text-align: center
    margin-bottom: 10%
    position: relative
    @include media-breakpoint-down($md)
        text-align: left
    @media print
        margin-bottom: .6cm
    &:after
        content: ""
        display: block
        position: absolute
        top: 100%
        width: auto
        left: 0
        right: 0
        margin-top: -70px
        z-index: -1
        height: 590px
        background: url('./../../assets/cross-red-fade.svg') repeat center
        background-size: 45px 45px
        background-position: 0 0
        margin-left: -12%
        margin-right: -12%
        // @include media-breakpoint-up($xxl)
        //     margin-left: calc((-100vw + 1920px) * 0.5)
        //     margin-right: calc((-100vw + 1920px) * 0.5)
    /deep/ h1
        max-width: 1140px
        margin-left: auto
        margin-right: auto
.baseline-row
    margin-bottom: 8%
.row
    display: flex
    @include media-breakpoint-down($lg)
        flex-direction: column
.division
    flex: 1
    .text
        max-width: 480px
        &.subtitle
            margin-left: auto
        @include media-breakpoint-down($lg)
            max-width: 100%
    &:first-child:last-child
        margin-left: 50%
        @include media-breakpoint-down($lg)
            margin-left: 0%
.cta
    margin-top: 8%
    border: 1px solid #e5e5e5
    @media print
        position: relative
        overflow: visible
        border: none
        &:after
            content: "https://www.soletanche-bachy.com" attr(href)
            font-size: 12px
            font-weight: normal
</style>
